import template from './signature-item.select.html';

const PROVIDER_TYPE = 'r';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.page.signature-block.signature-item.select',
    []
  )
  .component('tcSignatureItemSelect', {
    //tc-signature-item-select
    template,
    bindings: {
      me: '<',
      kind: '<',
      data: '<',
      disabled: '<',
    },
    controller: function (notificationFactory, roomHelpersFactory) {
      this.menuOpen = false;

      const currentRoom = roomHelpersFactory.getRoom();

      this.scrollInModalDialog = (top) => {
        document.querySelector('.modal-dialog').scrollTo({
          top: top,
          behavior: 'smooth',
        });
      };

      this.togglMenu = (event) => {
        if (this.disabled) return;
        const element = event.target.closest(
          '.teleconsent-signature-dropdown-wrapper'
        );
        const offsetTop =
          element.offsetTop === 0
            ? element.offsetParent.offsetTop
            : element.offsetTop;
        const wrapperHeight =
          document.querySelector('.modal-dialog').offsetHeight;
        this.scrollInModalDialog(offsetTop - wrapperHeight / 2);
        this.menuOpen = !this.menuOpen;
      };

      this.scrollToDrawItem = (event) => {
        setTimeout(() => {
          const element = event.target.closest(
            '.teleconsent-signature-wrapper'
          );
          const offsetTop =
            element.offsetTop === 0
              ? element.offsetParent.offsetTop
              : element.offsetTop;
          const wrapperHeight = element.offsetHeight;
          this.scrollInModalDialog(offsetTop - wrapperHeight / 2);
        }, 0);
      };

      this.closeMenu = () => {
        if (this.disabled) return;
        this.menuOpen = false;
      };

      this.onPhotoOptionClicked = () => {
        if (
          this.me.type === PROVIDER_TYPE &&
          currentRoom &&
          currentRoom.cameraOff
        ) {
          notificationFactory.showCommon('error', 'teleconsent-camera-off');
          return;
        }
        this.data.state = 'photo';
      };
    },
  }).name;
